export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9542.fe490cf0.jpg";